export const routeConfig = [
    '$urlMatcherFactoryProvider',
    '$urlRouterProvider',
    '$locationProvider',
    'wtConfigProvider',
    ($urlMatcherFactoryProvider, $urlRouterProvider, $locationProvider, wtConfigProvider) => {
        $urlMatcherFactoryProvider.caseInsensitive(true);
        $urlRouterProvider.otherwise('/notFound');

        const isKeycloakEnabled = wtConfigProvider.keycloakEnabled === true;
        if (isKeycloakEnabled) {
            $locationProvider.html5Mode({
                enabled: true,
                requireBase: false
            });
        }
    }
];
